import { Skeleton } from '@common/components';

export const PopularPolicySkeleton = () => {
  return (
    <section>
      <div className="px-28 pb-16">
        <Skeleton className="mb-4 h-22 w-120 rounded-xsmall" />
        <Skeleton className="h-20 w-280 rounded-xsmall" />
      </div>

      <div className="overflow-hidden px-20">
        <div className="flex">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="mr-8 flex w-220 shrink-0 flex-col justify-between rounded-xlarge bg-Gray-white p-20"
            >
              <div className="flex flex-col gap-2">
                <Skeleton className="mb-2 h-18 w-32 rounded-xsmall" />
                <Skeleton className="mb-12 h-18 w-full rounded-xsmall" />
              </div>
              <div>
                <Skeleton className="mb-4 h-18 w-120 rounded-xsmall" />
                <div className="flex items-center gap-2 pt-4">
                  <Skeleton className="size-12 rounded-xsmall" />
                  <Skeleton className="h-18 w-80 rounded-xsmall" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
